import { makeObservable } from 'mobx';
import { Filtro } from './Filtro';

export default class FiltroDestaquesPorMagistrado extends Filtro {
    tipo = 'selecao';
    exibicao = 'select';
    selecaoMultipla = true;

    get label() {
        return 'Manifestações (Destaques) por magistrado';
    }

    constructor(props) {
        super(props);
        makeObservable(this);
    }

    #siglasMagistradoDestaques(registro) {
        const destaquesProcesso = [];

        if (registro.contabilizacoesObservacao) {
            for (const observacao of registro.contabilizacoesObservacao) {
                if (observacao.tipoObservacao === 'DESTAQUE' && observacao.visibilidade === 'PUBLICA') {
                    destaquesProcesso.push(observacao.siglaMagistrado);
                }
            }
        }

        return destaquesProcesso;
    }

    getValorOpcao(registro) {
        let retorno = [];
        const destaquesProcesso = this.#siglasMagistradoDestaques(registro);

        if (destaquesProcesso) {
            retorno = retorno.concat(destaquesProcesso);
        }

        return retorno;
    }
}
